export default "__VITE_ASSET__BJeJqdum__"